import React from "react";

/**
 * Official "Download on the App Store" badge (Apple).
 * Black variant — embedded SVG so it survives offline / PWA caching.
 * Renders as an external <a> linking directly to the live App Store page.
 *
 * Reference: https://developer.apple.com/app-store/marketing/guidelines/
 */
const APP_STORE_URL = "https://apps.apple.com/it/app/vita-da-host/id6760694341";

export default function AppStoreLink({
  className = "",
  testid = "appstore-link",
  // `compact` matches the sibling button's height so they line up nicely
  // in the Android/Desktop CTA row on AppUfficialiPage.
  compact = false,
}) {
  const heightClass = compact ? "h-12 md:h-14" : "h-14 md:h-16";
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scarica Vita da Host su App Store"
      data-testid={testid}
      className={`group inline-flex items-center justify-center rounded-2xl bg-black border border-white/15 hover:border-white/40 px-4 ${heightClass} transition-all hover:bg-white/[0.04] active:scale-[0.98] ${className}`}
    >
      {/* Apple logo + "Download on the App Store" */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 40"
        className="h-full w-auto"
        aria-hidden
        focusable="false"
      >
        {/* Apple logo */}
        <g fill="#fff">
          <path d="M21.99 20.66c-.03-3.21 2.62-4.76 2.74-4.83-1.5-2.18-3.83-2.48-4.66-2.52-1.99-.2-3.88 1.17-4.89 1.17-1.02 0-2.57-1.14-4.23-1.11-2.18.03-4.19 1.27-5.31 3.22-2.26 3.91-.58 9.68 1.62 12.86 1.07 1.56 2.34 3.31 4 3.25 1.61-.07 2.22-1.04 4.16-1.04 1.93 0 2.49 1.04 4.19 1 1.73-.03 2.82-1.58 3.87-3.15 1.22-1.81 1.72-3.55 1.75-3.64-.04-.02-3.36-1.29-3.39-5.11zM18.7 11.46c.88-1.06 1.46-2.55 1.3-4.02-1.26.05-2.78.84-3.69 1.9-.81.94-1.52 2.45-1.33 3.9 1.4.11 2.84-.71 3.72-1.78z"/>
        </g>
        {/* "Scarica su" — micro text */}
        <text x="32" y="15" fill="#fff" fontSize="7.5" fontFamily="-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif" letterSpacing="0.4">
          Scarica su
        </text>
        {/* "App Store" — primary text */}
        <text x="32" y="30" fill="#fff" fontSize="14.5" fontWeight="600" fontFamily="-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif" letterSpacing="-0.3">
          App Store
        </text>
      </svg>
    </a>
  );
}

export { APP_STORE_URL };
